var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAscendingCopy52(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B8D3D9A5-93C7-42C1-89AD-AF00777D5263") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-706.000000, -836.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-52",
    transform: "translate(706.000000, 836.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9653373,16.4631409 L17.1775674,16.4631409 L16.8983578,16.194061 C18.0949703,14.7988315 18.7132201,12.8953398 18.3741799,10.872257 C17.9055066,8.10172988 15.5920558,5.88929454 12.79996,5.55045309 C8.58190099,5.03222499 5.0319506,8.58009428 5.55048268,12.7956805 C5.88952289,15.5861395 8.10325599,17.8982341 10.8754083,18.3666326 C12.8996777,18.7054741 14.8042859,18.0875867 16.2003338,16.8916757 L16.4695716,17.1707216 L16.4695716,17.9580297 L20.7075742,22.1935478 C21.1164168,22.6021507 21.7845254,22.6021507 22.193368,22.1935478 C22.6022107,21.7849449 22.6022107,21.1172279 22.193368,20.708625 L17.9653373,16.4631409 Z M11.977297,16.9587466 C9.21765933,16.9587466 6.99,14.7323932 6.99,11.9743733 C6.99,9.2163534 9.21765933,6.99 11.977297,6.99 C14.7369347,6.99 16.964594,9.2163534 16.964594,11.9743733 C16.964594,14.7323932 14.7369347,16.9587466 11.977297,16.9587466 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendingCopy52);
export default __webpack_public_path__ + "static/media/ascending Copy 52.9b1a7c8ae8be2e1f2574541da843372a.svg";
export { ForwardRef as ReactComponent };